import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import './FeaturedSandwich.css';

const FeaturedSandwich = () => {
  return (
    <section className="featured-sandwich">
      <div className="container">
        <div className="featured-badge">
          <span className="star-icon">
            <FontAwesomeIcon icon={faStar} />
          </span>
          <span>Featured Special</span>
        </div>
        <div className="featured-content">
          <div className="featured-details">
            <h2 className="force-revue">The Corned Beef Special</h2>
            <p className="featured-description">
              6oz of Corned Beef, on rye with coleslaw, Swiss cheese and Russian dressing.
            </p>
            <div className="featured-meta">
              <div className="featured-price">$17.99</div>
              <a href="tel:248-352-7377" className="btn primary">
                <FontAwesomeIcon icon={faPhoneAlt} /> Order Now
              </a>
            </div>
          </div>
          <div className="featured-image-container">
            <div className="featured-image"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSandwich;